import Template from "../../components/Template";
import { useNavigate } from 'react-router-dom';
import { useNavigation } from '../../context/NavigationContext';
import React, { useState, useEffect, useRef } from "react";
import api from "../../services/api";
import config from "../../config";
import * as XLSX from "xlsx";
import AlertDialog from "../../components/AlertDialog";
import { Link } from "react-router-dom";
import usePermission from "../../hooks/usePermission";
import useListFilterState from "../../hooks/useListFilterState";
import { formatCurrencyFromDb, maskCurrency } from "../../utils/masks";
import { formatDateWithHour, formatDateWithoutHour } from "../../utils/date";

import useRequisicaoMaisRecente from '../../hooks/useRequisicaoMaisRecente';
const Impostos = () => {
    const navigate = useNavigate();
    const { updateMenu } = useNavigation();
    const [impostos, setImpostos] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const { filters, setFilters, pageSize, setPageSize, isSearchActive, setIsSearchActive, clearPersistedState } = useListFilterState('impostos', {
        descricao: "",
        tipoId: "",
        statusId: "",
    });
    const [columns, setColumns] = useState([
        {
            id: "id",
            label: "ID",
            visible: true,
            formatter: (value) => (
                <Link to={`/impostos/editar/${value}`} className="text-stone-600 hover:underline">
                    {value}
                </Link>
            ),
        },
        {
            id: "descricao",
            label: "Descrição",
            visible: true,
            formatter: (value) => value
        },
        {
            id: "tipo",
            label: "Tipo",
            visible: true,
            formatter: (value, row) => value?.nome || "-"
        },

        {
            id: "valor",
            label: "Valor",
            visible: true,
            formatter: (value) => formatCurrencyFromDb(value) || "",
        },
        {
            id: "dataVencimento",
            label: "Vencimento",
            visible: true,
            formatter: (value) =>
                value ? formatDateWithoutHour(value) : "",
        },
        {
            id: "dataPagamento",
            label: "Pagamento",
            visible: true,
            formatter: (value) =>
                value ? formatDateWithoutHour(value) : "",
        },
        {
            id: "status",
            label: "Status",
            visible: true,
            formatter: (value) => value?.nome || "-"
        },
        {
            id: "referencia",
            label: "Referência",
            visible: true,
            formatter: (value) => value || "-"
        },
        {
            id: "acoes",
            label: "Ações",
            visible: true,
            formatter: (value, row) => (
                <div className="flex items-center justify-center gap-2">
                    <button
                        onClick={() => handleShowAnexosModal(row)}
                        className="p-1 hover:bg-stone-100 rounded"
                        title="Anexar Documentos"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
                        </svg>
                    </button>
                </div>
            ),
        },
    ]);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [message, setMessage] = useState("");
    const [menuOpen, setMenuOpen] = useState(false);
    const [tipos, setTipos] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const buttonRef = useRef(null);
    const buttonFiltrarRef = useRef(null);

    // Modal de anexos/documentos
    const [showAnexosModal, setShowAnexosModal] = useState(false);
    const [selectedImposto, setSelectedImposto] = useState(null);
    const [anexosImposto, setAnexosImposto] = useState([]);
    const [tiposDocumentos, setTiposDocumentos] = useState([]);
    const [anexoTipoId, setAnexoTipoId] = useState('');
    const [anexoFile, setAnexoFile] = useState(null);
    const [loadingAnexos, setLoadingAnexos] = useState(false);
    const [enviandoAnexo, setEnviandoAnexo] = useState(false);

    // Modal de preview de arquivo
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [selectedPdfUrl, setSelectedPdfUrl] = useState(null);

    useEffect(() => {
        fetchImpostos(currentPage, pageSize);
        fetchTipos();
        fetchStatus();
    }, [currentPage]);

    // Descarta respostas de filtros que já foram superados por outro mais novo:
    // sem isto, a resposta lenta de um filtro anterior sobrescrevia a tela.
    const requisicaoMaisRecente = useRequisicaoMaisRecente();

    const fetchImpostos = async (page, size, filtrosParaUsar = filters) => {
        try {
            const params = {
                page,
                pageSize: size,
                ...filtrosParaUsar
            };
            const query = new URLSearchParams(params).toString();
            const idRequisicao = requisicaoMaisRecente.iniciar();
            const response = await api.get(`/impostos?${query}`);
            // Chegou atrasada e ja foi superada por outro filtro: descarta.
            if (!requisicaoMaisRecente.ehAtual(idRequisicao)) return;

            setImpostos(response.data.records);
            setTotalRecords(response.data.total);
            setPageSize(size);
        } catch (error) {
            console.error("Erro ao carregar dados:", error);
        }
    };

    const fetchFilteredImpostos = async (query) => {
        try {
            const params = new URLSearchParams(query).toString();
            const idRequisicao = requisicaoMaisRecente.iniciar();
            const response = await api.get(`/impostos?${params}`);
            // Chegou atrasada e ja foi superada por outro filtro: descarta.
            if (!requisicaoMaisRecente.ehAtual(idRequisicao)) return;


            setImpostos(response.data.records);
            setTotalRecords(response.data.total);
            setCurrentPage(1);
        } catch (error) {
            console.error("Erro ao aplicar filtros:", error);
        }
    };

    const fetchTipos = async () => {
        try {
            const resp = await api.get("/tiposimposto");
            setTipos(resp.data);
        } catch (err) { }
    };

    const fetchStatus = async () => {
        try {
            const resp = await api.get("/statuses/byModule/nome/impostos");
            setStatusList(resp.data);
        } catch (err) { }
    };

    // ==========================================
    // FUNÇÕES DE ANEXOS/DOCUMENTOS
    // ==========================================

    const fetchTiposDocumentos = async () => {
        try {
            const response = await api.get('/tiposdocumentos');
            setTiposDocumentos(response.data);
        } catch (error) {
            console.error("Erro ao carregar tipos de documentos:", error);
        }
    };

    const fetchAnexosImposto = async (impostoId) => {
        try {
            setLoadingAnexos(true);
            const response = await api.get(`/impostos/${impostoId}/anexos`);
            setAnexosImposto(response.data);
        } catch (error) {
            console.error("Erro ao carregar anexos:", error);
            setMessage("Erro ao carregar documentos do imposto");
            setShowSuccessDialog(true);
        } finally {
            setLoadingAnexos(false);
        }
    };

    const handleShowAnexosModal = async (imposto) => {
        setSelectedImposto(imposto);
        setShowAnexosModal(true);
        setAnexoTipoId('');
        setAnexoFile(null);

        if (tiposDocumentos.length === 0) {
            await fetchTiposDocumentos();
        }
        await fetchAnexosImposto(imposto.id);
    };

    const handleAddAnexo = async () => {
        if (!anexoTipoId) {
            setMessage("Selecione um tipo de documento");
            setShowSuccessDialog(true);
            return;
        }
        if (!anexoFile) {
            setMessage("Selecione um arquivo");
            setShowSuccessDialog(true);
            return;
        }

        try {
            setEnviandoAnexo(true);
            const formData = new FormData();
            formData.append('tipoId', anexoTipoId);
            formData.append('file', anexoFile, anexoFile.name);

            await api.post(`/impostos/${selectedImposto.id}/anexos`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            setMessage("Documento anexado com sucesso!");
            setShowSuccessDialog(true);
            setAnexoTipoId('');
            setAnexoFile(null);
            await fetchAnexosImposto(selectedImposto.id);
        } catch (error) {
            console.error("Erro ao anexar documento:", error);
            setMessage(error.response?.data?.error || "Erro ao anexar documento");
            setShowSuccessDialog(true);
        } finally {
            setEnviandoAnexo(false);
        }
    };

    const handleRemoveAnexo = async (anexoId) => {
        if (!window.confirm('Deseja realmente remover este documento?')) {
            return;
        }

        try {
            await api.delete(`/impostos/${selectedImposto.id}/anexos/${anexoId}`);
            setMessage("Documento removido com sucesso!");
            setShowSuccessDialog(true);
            await fetchAnexosImposto(selectedImposto.id);
        } catch (error) {
            console.error("Erro ao remover documento:", error);
            setMessage("Erro ao remover documento");
            setShowSuccessDialog(true);
        }
    };

    const handleViewAnexo = (arquivo) => {
        if (arquivo) {
            setSelectedPdfUrl(config.urlArquivo(arquivo));
            setShowPdfModal(true);
        }
    };

    // ==========================================
    // FIM DAS FUNÇÕES DE ANEXOS
    // ==========================================

    const handlePageChange = (page) => setCurrentPage(page);

    const totalPages = Math.ceil(totalRecords / pageSize);
    const startRecord = totalRecords > 0 ? (currentPage - 1) * pageSize + 1 : 0;
    const endRecord = Math.min(currentPage * pageSize, totalRecords);
    const pageWindowSize = 5;
    // Mantem a janela cheia tambem nas ultimas paginas (antes ela encolhia).
    const startPage = Math.max(1, Math.min(currentPage - Math.floor(pageWindowSize / 2), totalPages - pageWindowSize + 1));
    const endPage = Math.min(totalPages, startPage + pageWindowSize - 1);
    const pageNumbers = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);

    const toggleColumnVisibility = (id) => {
        setColumns((prev) =>
            prev.map((col) =>
                col.id === id ? { ...col, visible: !col.visible } : col
            )
        );
    };

    const clearFilters = () => {
        // `fetchImpostos` le `filters` pelo closure; chamando-o aqui ele ainda
        // enxergava os filtros ANTIGOS e a lista continuava filtrada. Passamos
        // os filtros explicitamente.
        const vazios = { descricao: "", tipoId: "", statusId: "" };
        clearPersistedState();
        setFilters(vazios);
        setCurrentPage(1);
        fetchImpostos(1, pageSize, vazios);
    };

    const applyFilters = () => {
        setCurrentPage(1);
        fetchImpostos(1, pageSize);
    };

    const handleSearch = () => {
        setCurrentPage(1); // Reinicia para a primeira página
        const query = {
            ...filters,
            page: 1,
            pageSize,
        };
        fetchFilteredImpostos(query); // Executa a busca com o termo atual
    };

    useEffect(() => {
        if (menuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);

        };
    }, [menuOpen]);

    const handleMenuClick = (event) => {
        event.stopPropagation();
    };

    const handleClickOutside = (event) => {
        if (
            buttonRef.current &&
            !buttonRef.current.contains(event.target) &&
            buttonFiltrarRef.current &&
            !buttonFiltrarRef.current.contains(event.target)
        ) {
            setMenuOpen(null);
        }
    };

    // Exportação
    const exportToExcel = () => {
        if (impostos.length === 0) {
            setMessage('Não há dados para exportar!');
            setShowSuccessDialog(true);
            return;
        }

        const monetaryColumns = ['valor']; // substitua pelos IDs reais

        const dataToExport = impostos.map((doc) => {
            const row = {};
            columns.forEach((col) => {
                if (col.visible) {
                    // Formatters de coluna que devolvem JSX (links, botoes, checkboxes)
                    // viravam "[object Object]" na planilha: nesses casos exporta o valor bruto.
                    let value = col.formatter ? col.formatter(doc[col.id], doc) : doc[col.id];
                    if (value && typeof value === 'object') value = doc[col.id];

                    // Remove formatação monetária (p.ex. 'R$', '.', ',') e converte para número
                    if (monetaryColumns.includes(col.id)) {
                        value = Number(String(value)
                            .replace(/[R$\s.]/g, '')
                            .replace(',', '.')
                        );
                    }

                    row[col.label] = value;
                }
            });
            return row;
        });
        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        // Formata células monetárias explicitamente como números no Excel
        const columnLabels = columns.filter(col => col.visible).map(col => col.label);
        monetaryColumns.forEach((colId) => {
            const colIndex = columnLabels.indexOf(columns.find(c => c.id === colId)?.label);
            if (colIndex >= 0) {
                const columnLetter = XLSX.utils.encode_col(colIndex);
                const range = XLSX.utils.decode_range(worksheet['!ref']);

                for (let i = range.s.r + 1; i <= range.e.r; i++) {
                    const cellAddress = `${columnLetter}${i + 1}`;
                    if (worksheet[cellAddress]) {
                        worksheet[cellAddress].t = 'n';
                        worksheet[cellAddress].z = '#,##0.00';
                    }
                }
            }
        });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Impostos");
        XLSX.writeFile(workbook, "impostos.xlsx");
    };

    return (
        <Template>
            <div className="h-auto w-full p-4 md:p-8 flex flex-col gap-6">
                <div className="flex flex-wrap justify-between items-center gap-4">
                    <div className="text-stone-800 text-xl md:text-2xl font-medium">Impostos</div>
                </div>
                <div className="flex flex-wrap gap-2 md:gap-4 items-center">
                    <div className="flex-grow min-w-0 flex items-center gap-2">
                        <div className="text-stone-600 text-sm font-medium">Ver</div>
                        <select
                            className="w-20 h-8 pl-2 pr-2 py-1 bg-white rounded-md border border-slate-300 text-sm text-slate-700"
                            value={pageSize}
                            onChange={(e) => {
                                const newPageSize = parseInt(e.target.value, 10);
                                setPageSize(newPageSize);
                                setCurrentPage(1);
                                fetchImpostos(1, newPageSize);
                            }}
                        >
                            {[5, 10, 25, 50, 100].map((opt) => (
                                <option key={opt} value={opt}>{opt}</option>
                            ))}
                        </select>
                        <div className="text-stone-600 text-sm font-medium">Resultados</div>
                    </div>
                    <div className="flex flex-wrap gap-2 flex-none w-full md:w-auto">
                        {/* Colunas */}
                        <div ref={buttonRef} className="relative justify-end items-center gap-1 flex cursor-pointer" onClick={() => setMenuOpen(menuOpen === "colunas" ? null : "colunas")}>
                            <div className="justify-start items-center gap-2 flex" >
                                <img className="w-6 h-6" src="images/icon/columns.png" />
                                <div className="text-stone-600 text-sm font-medium">Colunas</div>
                            </div>
                            <img className="w-6 h-4 px-1" src="images/icon/chevron-down.png" />
                            {menuOpen === "colunas" && (
                                <div className="absolute top-full left-0 mt-2 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-50"
                                    style={{
                                        zIndex: 9999, // Garante que está acima de outros elementos
                                    }}
                                    onClick={handleMenuClick}
                                >
                                    <div className="p-4 flex flex-col gap-3">
                                        {columns.map((col) => (
                                            <div key={col.id} className="flex items-center gap-2">
                                                <input
                                                    type="checkbox"
                                                    id={col.id}
                                                    checked={col.visible}
                                                    onChange={() => toggleColumnVisibility(col.id)}
                                                />
                                                <label htmlFor={col.id} className="text-sm text-gray-700">{col.label}</label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                        {/* Filtro */}
                        <div ref={buttonFiltrarRef} className="relative justify-start items-center gap-1 flex cursor-pointer" onClick={() => setMenuOpen(menuOpen === "filtro" ? null : "filtro")} >
                            <div className="justify-start items-center gap-2 flex">
                                <img className="w-8 h-8 px-0.5 py-[3px]" src="images/icon/filter.png" />
                                <div className="text-stone-600 text-sm font-medium">Filtrar</div>
                            </div>
                            <img className="w-6 h-4 px-1" src="images/icon/chevron-down.png" />
                            {menuOpen === "filtro" && (
                                <div className="absolute top-full left-0 mt-2 w-[350px] bg-white rounded-md shadow-lg z-50 p-4 border border-gray-300" style={{ zIndex: 9999 }} onClick={handleMenuClick} >
                                    <div className="flex flex-col gap-4">
                                        <div className="text-stone-800 text-xl font-medium">Filtrar</div>
                                        <div className="flex flex-col gap-1.5">
                                            <div className="text-slate-700 text-sm font-medium">Descrição</div>
                                            <input type="text" className="w-full px-3 py-2 bg-white rounded-md border border-slate-300" placeholder="Digite a descrição"
                                                value={filters.descricao} onChange={(e) => setFilters((prev) => ({ ...prev, descricao: e.target.value }))} />
                                        </div>
                                        <div className="flex flex-col gap-1.5">
                                            <div className="text-slate-700 text-sm font-medium">Tipo</div>
                                            <select className="w-full px-3 py-2 bg-white rounded-md border border-slate-300"
                                                value={filters.tipoId} onChange={e => setFilters(prev => ({ ...prev, tipoId: e.target.value }))}>
                                                <option value="">Todos</option>
                                                {tipos.map((t) => <option key={t.id} value={t.id}>{t.nome}</option>)}
                                            </select>
                                        </div>
                                        <div className="flex flex-col gap-1.5">
                                            <div className="text-slate-700 text-sm font-medium">Status</div>
                                            <select className="w-full px-3 py-2 bg-white rounded-md border border-slate-300"
                                                value={filters.statusId} onChange={e => setFilters(prev => ({ ...prev, statusId: e.target.value }))}>
                                                <option value="">Todos</option>
                                                {statusList.map((s) => <option key={s.id} value={s.id}>{s.nome}</option>)}
                                            </select>
                                        </div>
                                        <div className="self-stretch flex items-center justify-between gap-4 mt-4">
                                            <button className="px-4 py-2 w-full bg-white rounded-md border border-stone-500 justify-center items-center gap-2 flex"
                                                onClick={clearFilters}>
                                                <img className="w-4 h-4" src="images/icon/eraser.png" />
                                                <div className="text-stone-500 text-sm font-medium">Limpar</div>
                                            </button>
                                            <button className="px-4 py-2 w-full bg-stone-600 rounded-md justify-center items-center gap-2 flex"
                                                onClick={applyFilters}>
                                                <img className="w-4 h-4" src="images/icon/filter-white.png" />
                                                <div className="text-white text-sm font-medium">Filtrar</div>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            )}
                        </div>
                        <div className="justify-start items-center gap-2 flex">
                            {!isSearchActive ? (
                                // Conteúdo original da div "Pesquisar"
                                <div
                                    className="justify-start items-center gap-2 flex cursor-pointer"
                                    onClick={() => setIsSearchActive(true)} // Ativar o estado de pesquisa
                                >
                                    <img className="w-10 h-10 relative" src="images/icon/search.png" alt="Ícone Pesquisar" />
                                    <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-normal">Pesquisar</div>
                                </div>
                            ) : (
                                // Conteúdo alternativo ao ativar o estado de pesquisa
                                <div className="h-10 justify-start items-center gap-2 inline-flex">
                                    <div className="h-9 px-3 py-2 bg-white rounded-md border border-slate-300 justify-start items-center flex">
                                        <input
                                            type="text"
                                            placeholder="Pesquisar pelo nome"
                                            className="w-full text-slate-400 text-base font-normal font-['Inter'] leading-tight focus:outline-none"
                                            value={filters.descricao}
                                            onChange={(e) =>
                                                setFilters({ ...filters, descricao: e.target.value })
                                            }
                                        />
                                        <img className="w-6 h-6 p-[3.33px] justify-center items-center flex cursor-pointer" src="images/icon/close.png" onClick={() => {
                                            setIsSearchActive(false);
                                        }} />
                                    </div>
                                    <button
                                        className="px-4 py-2 bg-stone-600 rounded-md justify-center items-center gap-2 flex"
                                        onClick={handleSearch}
                                    >
                                        <img className="w-4 h-4 relative" src="images/icon/search-white.png" alt="Ícone Pesquisar" />
                                        <div className="text-white text-sm font-medium font-['Inter'] leading-normal">Pesquisar</div>
                                    </button>
                                </div>
                            )}
                        </div>
                        {/* Exportar */}
                        {usePermission('EXPORTAR_IMPOSTO') && (
                            <button type='button' className="flex px-4 py-2 bg-white/40 rounded-md border border-stone-600 justify-center items-center gap-2 cursor-pointer" onClick={exportToExcel}>
                                <img className="w-4 h-4" src="images/icon/upload.png" />
                                <div className="text-stone-600 text-sm font-medium">Exportar</div>
                            </button>
                        )}
                        {/* Cadastrar */}
                        {usePermission('CRIAR_IMPOSTO') && (
                            <button type='button' className="px-4 py-2 bg-stone-600 text-white rounded-md flex items-center gap-2" onClick={() => navigate('/impostos/cadastrar')}>
                                <img className="w-4 h-4" src="images/icon/plus-circle.png" />
                                <div className="text-white text-sm font-medium">Cadastrar</div>
                            </button>
                        )}
                    </div>
                </div>
                {/* Tabela */}
                <div className="overflow-x-auto md:overflow-x-visible">
                    <table className="min-w-full bg-white border-collapse border border-gray-200">
                        <thead className="bg-stone-200">
                            <tr>
                                {columns.filter(col => col.visible).map(col => (
                                    <th key={col.id} className="px-4 py-2 border border-slate-200 text-slate-800 text-base font-bold">{col.label}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {impostos.map((imp) => (
                                <tr key={imp.id} >
                                    {columns.filter(col => col.visible).map(col => (
                                        <td key={col.id} className="px-4 py-2 border border-slate-200 text-slate-700 text-base">
                                            {col.formatter ? col.formatter(imp[col.id], imp) : imp[col.id]}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        {totalRecords === 0 && (
                            <tr>
                                <td
                                    colSpan={columns.filter((col) => col.visible).length || 1}
                                    className="px-4 py-6 border border-slate-200 text-center text-slate-500 text-base"
                                >
                                    Nenhum registro encontrado.
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
                {/* Paginação */}
                <div className="self-stretch justify-end items-center gap-2.5 inline-flex">
                    <div className="grow shrink basis-0 text-slate-500 text-base font-normal">
                        Mostrando de {startRecord} até {endRecord} de {totalRecords} registros.
                    </div>
                    <div className="justify-start items-start gap-4 flex">
                        <button className={`w-10 h-10 bg-white/0 rounded border border-[#bebebe] justify-center items-center flex ${currentPage === 1 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-300 cursor-pointer"}`}
                            disabled={currentPage === 1}
                            onClick={() => handlePageChange(currentPage - 1)}
                        >
                            <img className="w-6 h-6" src="images/icon/keyboard-arrow-left.png" />
                        </button>
                        {pageNumbers.map((page) => (
                            <button key={page}
                                className={`w-10 h-10 rounded justify-center items-center flex text-base font-semibold ${page === currentPage ? "bg-stone-600 text-white" : "bg-gray-200 text-gray-600"}`}
                                onClick={() => handlePageChange(page)}>
                                {page}
                            </button>
                        ))}
                        <button className={`w-10 h-10 bg-white/0 rounded border border-[#bebebe] justify-center items-center flex 
                        ${currentPage >= totalPages || totalPages === 0 ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'}`}
                            disabled={currentPage >= totalPages || totalPages === 0}
                            onClick={() => handlePageChange(currentPage + 1)}>
                            <img className="w-6 h-6" src="images/icon/keyboard-arrow-right.png" />
                        </button>
                    </div>
                </div>
            </div>

            {/* Modal de Preview de Arquivo */}
            {showPdfModal && (
                <div className="fixed inset-0 bg-black/90 p-10 flex-col justify-start items-end gap-10 inline-flex overflow-hidden" style={{ zIndex: 60 }}>
                    <div className="rounded-lg w-full max-w-[80%] h-full max-h-[90%] flex flex-col">
                        <div className="flex justify-between items-center p-4">
                            <div className="flex items-center gap-4">
                                <a href={selectedPdfUrl} download target="_blank" rel="noreferrer">
                                    <img className="w-6 h-6" src="images/icon/download.png" alt="Download" />
                                </a>
                            </div>
                            <img
                                className="w-6 h-6 cursor-pointer"
                                src="images/icon/x.png"
                                onClick={() => setShowPdfModal(false)}
                                alt="Fechar"
                            />
                        </div>
                        <div className="flex-grow flex justify-center items-center p-4 overflow-hidden">
                            <iframe
                                src={`${selectedPdfUrl}#toolbar=0`}
                                className="w-full h-full border-0"
                                title="PDF Viewer"
                            />
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Anexos/Documentos */}
            {showAnexosModal && selectedImposto && (
                <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto">
                        <div className="p-6">
                            <div className="flex justify-between items-center mb-6">
                                <h2 className="text-xl font-bold text-gray-800">Documentos do Imposto</h2>
                                <button onClick={() => setShowAnexosModal(false)} className="p-2 hover:bg-gray-100 rounded">
                                    <img className="w-6 h-6" src="images/icon/close.png" alt="Fechar" />
                                </button>
                            </div>

                            {/* Informações do Imposto */}
                            <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                                <div className="text-sm font-medium text-gray-700 mb-2">Imposto Selecionado</div>
                                <div className="grid grid-cols-2 gap-2 text-sm">
                                    <div>
                                        <span className="text-gray-500">Descrição:</span>
                                        <span className="ml-2 text-gray-800">{selectedImposto.descricao}</span>
                                    </div>
                                    <div>
                                        <span className="text-gray-500">Valor:</span>
                                        <span className="ml-2 text-gray-800 font-medium">{formatCurrencyFromDb(selectedImposto.valor)}</span>
                                    </div>
                                    <div>
                                        <span className="text-gray-500">Vencimento:</span>
                                        <span className="ml-2 text-gray-800">{selectedImposto.dataVencimento ? formatDateWithoutHour(selectedImposto.dataVencimento) : '-'}</span>
                                    </div>
                                    <div>
                                        <span className="text-gray-500">Tipo:</span>
                                        <span className="ml-2 text-gray-800">{selectedImposto.tipo?.nome || '-'}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Formulário de Upload */}
                            <div className="mb-6">
                                <div className="text-sm font-medium text-gray-700 mb-3">Anexar Novo Documento</div>
                                <div className="flex flex-col md:flex-row gap-3">
                                    <div className="w-full md:w-[200px]">
                                        <select
                                            className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-slate-700 text-sm"
                                            value={anexoTipoId}
                                            onChange={(e) => setAnexoTipoId(e.target.value)}
                                        >
                                            <option value="">Tipo de Documento</option>
                                            {tiposDocumentos.map((tipo) => (
                                                <option key={tipo.id} value={tipo.id}>{tipo.nome}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="flex-1">
                                        <div className="relative flex items-center w-full">
                                            <input
                                                type="file"
                                                accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
                                                onChange={(e) => setAnexoFile(e.target.files[0])}
                                                className="absolute inset-0 opacity-0 cursor-pointer"
                                            />
                                            <div className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 flex items-center">
                                                <span className="text-sm text-slate-400 truncate">
                                                    {anexoFile ? anexoFile.name : "Selecionar arquivo..."}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <button
                                        onClick={handleAddAnexo}
                                        disabled={enviandoAnexo}
                                        className={`px-4 py-2 rounded-md text-white text-sm font-medium whitespace-nowrap ${
                                            enviandoAnexo 
                                                ? 'bg-gray-400 cursor-not-allowed' 
                                                : 'bg-stone-600 hover:bg-stone-700'
                                        }`}
                                    >
                                        {enviandoAnexo ? 'Enviando...' : 'Enviar'}
                                    </button>
                                </div>
                            </div>

                            {/* Lista de Documentos */}
                            <div>
                                <div className="text-sm font-medium text-gray-700 mb-3">
                                    Documentos Anexados ({anexosImposto.length})
                                </div>

                                {loadingAnexos ? (
                                    <div className="text-center py-8 text-gray-500">
                                        Carregando documentos...
                                    </div>
                                ) : anexosImposto.length === 0 ? (
                                    <div className="text-center py-8 text-gray-400 border border-dashed border-gray-300 rounded-lg">
                                        Nenhum documento anexado a este imposto.
                                    </div>
                                ) : (
                                    <div className="overflow-x-auto">
                                        <table className="border-collapse w-full min-w-max">
                                            <thead>
                                                <tr>
                                                    <th className="px-4 py-2 bg-stone-200 border border-slate-200 text-slate-800 text-sm font-bold text-left">Tipo</th>
                                                    <th className="px-4 py-2 bg-stone-200 border border-slate-200 text-slate-800 text-sm font-bold text-left">Arquivo</th>
                                                    <th className="px-4 py-2 bg-stone-200 border border-slate-200 text-slate-800 text-sm font-bold text-left">Data Envio</th>
                                                    <th className="px-4 py-2 bg-stone-200 border border-slate-200 text-slate-800 text-sm font-bold text-left">Enviado Por</th>
                                                    <th className="px-4 py-2 bg-stone-200 border border-slate-200 text-slate-800 text-sm font-bold text-center">Ações</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {anexosImposto.map((anexo) => (
                                                    <tr key={anexo.id}>
                                                        <td className="px-4 py-2 bg-white border border-slate-200 text-slate-700 text-sm">
                                                            <span className="px-2 py-1 bg-stone-100 rounded text-xs font-medium">
                                                                {anexo.tipo?.nome || '-'}
                                                            </span>
                                                        </td>
                                                        <td className="px-4 py-2 bg-white border border-slate-200 text-slate-700 text-sm truncate max-w-[200px]">
                                                            {anexo.arquivo?.split('/').pop() || '-'}
                                                        </td>
                                                        <td className="px-4 py-2 bg-white border border-slate-200 text-slate-700 text-sm">
                                                            {formatDateWithoutHour(anexo.dataEnvio)}
                                                        </td>
                                                        <td className="px-4 py-2 bg-white border border-slate-200 text-slate-700 text-sm">
                                                            {anexo.enviadoPor?.nome || '-'}
                                                        </td>
                                                        <td className="px-4 py-2 bg-white border border-slate-200 text-center">
                                                            <div className="flex justify-center gap-2">
                                                                {anexo.arquivo && (
                                                                    <button
                                                                        onClick={() => handleViewAnexo(anexo.arquivo)}
                                                                        className="p-1 hover:bg-stone-100 rounded"
                                                                        title="Visualizar"
                                                                    >
                                                                        <img className="w-5 h-5" src="images/icon/search-file.png" alt="Ver" />
                                                                    </button>
                                                                )}
                                                                <button
                                                                    onClick={() => handleRemoveAnexo(anexo.id)}
                                                                    className="p-1 hover:bg-red-100 rounded"
                                                                    title="Remover"
                                                                >
                                                                    <svg className="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>

                            {/* Botão Fechar */}
                            <div className="flex justify-end mt-6 pt-4 border-t">
                                <button
                                    onClick={() => setShowAnexosModal(false)}
                                    className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                                >
                                    Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Sucesso */}
            {showSuccessDialog && (
                <AlertDialog
                    message={message}
                    onClose={() => setShowSuccessDialog(false)}
                />
            )}
        </Template>
    );
};

export default Impostos;
